import { useNavigate } from "fusion-plugin-react-router";
import Lottie from "lottie-react";
import animationData from "../../../../../assets/animations/tbSuccessfulPaymentAnimation.json";
import QuoteFormWrapper from "../../../../../shared/components/quoteFormWrapper";
import Button from "../../../../../shared/components/Button";
import {
  clearAllStores,
  clearSupportStore,
} from "../../../../../shared/utils/storeUtils";
import useSupportStore from "../../../store/supportStore";
import QuoteStepHeading from "../../../../../shared/components/QuoteStepHeading";

const SpComplete = () => {
  const SUPPORT_STORE = useSupportStore();
  const isCancelPolicy = SUPPORT_STORE.Payload.Cancellation_Request__c;
  const navigate = useNavigate();

  const goToPortal = () => {
    clearSupportStore();
    clearAllStores();
    navigate("/landing");
  };

  return (
    <QuoteFormWrapper>
      <div className="tw-flex tw-flex-col tw-gap-4">
        <Lottie
          className="tw-h-[65px] tw-w-[65px] -tw-ml-3"
          animationData={animationData}
          loop={false}
          autoplay
          rendererSettings={{ preserveAspectRatio: "xMidYMid slice" }}
        />
        <QuoteStepHeading title="Complete" className="tw-mb-0" />
        <div className="tw-flex tw-flex-col tw-gap-3 tw-border-x-0 tw-border-t-0 tw-border-b tw-border-solid tw-border-dis-divider tw-pb-5 tw-mb-3">
          <p className="tw-m-0 tw-text-base tw-leading-[1.5] tw-text-dis-text-2">
            {isCancelPolicy
              ? "Thank you for providing your details. Your cancellation will be processed from the date and time provided above. You will receive your cancellation confirmation or quote with a breakdown of charges by close of business at 5pm."
              : "Thank you for providing the details. Your change will now be referred to our Underwriting department and you will receive a quote via email and SMS. Your quote will contain a payment link which will allow you to pay and accept the changes. Once we receive payment, we will then process the change for you and issue new documents to your email."}
          </p>
        </div>
        <Button fullWidth onClick={goToPortal}>
          Back to Portal
        </Button>
      </div>
    </QuoteFormWrapper>
  );
};

export default SpComplete;
